import { useQuery, useQueryClient } from 'react-query';
import { Http } from '../../services/Http';
import { QUERY_KEYS } from '../constants';
import { User } from '../../types';

async function fetchFilteredOpsTimesheets(
  startMonth: string,
  endMonth: string,
  status?: string,
  submitterLabel?: string
): Promise<User[]> {
  let url = `/user/operating-partners/filter?startMonth=${startMonth}&endMonth=${endMonth}`;
  if (status) {
    url += `&status=${status}`;
  }
  if (submitterLabel && submitterLabel !== 'all') {
    url += `&submitterLabel=${encodeURIComponent(submitterLabel)}`;
  }
  const { data } = await Http.axios.get<User[]>(url);
  return data;
}

// startMonth and endMonth are expected in 'YYYY-MM' format
export const useFilteredOpsTimesheets = (
  startMonth: string,
  endMonth: string,
  status?: string,
  submitterLabel?: string
) => {
  return useQuery(
    [QUERY_KEYS.USER_OPERATING_PARTNERS, startMonth, endMonth, status, submitterLabel],
    () => fetchFilteredOpsTimesheets(startMonth, endMonth, status, submitterLabel),
    {
      staleTime: Infinity,
      retry: false,
      refetchInterval: false,
      refetchOnMount: true,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
      refetchIntervalInBackground: false,
    }
  );
};

export const useInvalidateFilteredOpsTimesheets = () => {
  const queryClient = useQueryClient();

  return () => {
    queryClient.invalidateQueries({
      queryKey: QUERY_KEYS.USER_OPERATING_PARTNERS,
    });
  };
};